<script setup lang="ts">
import { ref, computed } from 'vue'
import { useTimer } from '@/shared/composables/useTimer'
import type { PuType } from '../lib/types'
import { isFieldEntered, SCORING_FIELD_PLACEHOLDER } from '../lib/scoringInput'

const type   = defineModel<PuType>('type',    { required: true })
const reps   = defineModel<string>('reps',    { required: true })
const exempt = defineModel<boolean>('exempt', { required: true })

const props = defineProps<{ componentScore: number | null }>()

const isOpen = ref(false)
const { startCountdown } = useTimer()

const timerSeconds = computed(() => type.value === 'hr' ? 120 : 60)
const timerLabel   = computed(() => type.value === 'hr' ? 'Hand Release Push-ups' : 'Push-ups')
const timerBtnText = computed(() => type.value === 'hr' ? 'Start 2:00 Timer' : 'Start 1:00 Timer')

const hasInput = computed(() => isFieldEntered(reps.value))

const pillText = computed(() => {
  if (exempt.value) return 'EXEMPT'
  if (!hasInput.value) return '–'
  if (props.componentScore !== null) return props.componentScore.toFixed(1) + ' pts'
  return '–'
})
</script>

<template>
  <div class="acc-card">
    <div class="acc-header" @click="isOpen = !isOpen">
      <div class="acc-header-left">
        <span class="acc-title">Push-ups</span>
        <span class="acc-pts">max 15 pts</span>
      </div>
      <label class="acc-exempt" @click.stop>
        <input type="checkbox" v-model="exempt" style="accent-color:var(--accent);width:14px;height:14px;" />
        Exempt
      </label>
      <span class="acc-score-pill" :class="{ 'has-score': !exempt && hasInput && componentScore !== null }">
        {{ pillText }}
      </span>
      <span class="acc-tap-hint">{{ isOpen ? 'tap to collapse' : 'tap to expand' }}</span>
      <span class="acc-chevron" :class="{ open: isOpen }" aria-hidden="true">
        <svg viewBox="0 0 24 24" focusable="false">
          <path d="m9 18 6-6-6-6" />
        </svg>
      </span>
    </div>

    <div v-show="isOpen" class="acc-body">
      <div :style="exempt ? { opacity: '0.35', pointerEvents: 'none' } : {}">
        <div class="row">
          <div class="field">
            <label>Type</label>
            <div class="toggle-group">
              <button :class="['toggle-btn', { active: type === 'standard' }]" @click="type = 'standard'">Standard (1 min)</button>
              <button :class="['toggle-btn', { active: type === 'hr' }]"       @click="type = 'hr'">Hand Release (2 min)</button>
            </div>
          </div>
          <div class="field sm">
            <label>Reps</label>
            <input type="text" inputmode="numeric" :placeholder="SCORING_FIELD_PLACEHOLDER" v-model="reps" aria-label="Push-ups reps" />
          </div>
        </div>
        <div v-if="!exempt" style="display:block;margin-top:10px;">
          <button class="calc-timer-btn" @click="startCountdown(timerSeconds, timerLabel)">
            {{ timerBtnText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
